exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".description[data-v-14976853]{font-size:80%;font-weight:400}.space-top[data-v-14976853]{margin-top:1em}.tab-label label.display-flex[data-v-14976853]{margin-top:0!important}.tab-label[data-v-14976853]{margin-bottom:0!important}.speech-input[data-v-14976853]{position:absolute;right:0;bottom:0}.input-text[data-v-14976853]{padding-right:1.3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-14976853","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/common/form-elements/TextBoxWithLabel.vue
// module id = 842
// module chunks = 38